import { formatUtcToLocal, valueOrEmpty } from "../../../utils/helpers/text";
import { createDateTimeCellRenderer } from "../../../components/shared/DateTimeCellRenderer";

/**
 * Creates ag-grid column config overrides for the Creation Date column.
 * @param {object} filterParams - Shared date filter params
 * @returns {object} Column config overrides
 */
export const createCreatedAtColumnConfig = (filterParams) => ({
  filter: "agDateColumnFilter",
  filterParams,
  sortable: true,
  cellRenderer: createDateTimeCellRenderer('createdAt', null, null),
  valueFormatter: (params) => params?.value ? formatUtcToLocal(params.value, { variant: 'date' }) : '-',
  filterValueGetter: (params) => {
    return params?.data?.createdAt ? formatUtcToLocal(params.data.createdAt, { variant: 'date' }) : '';
  },
  comparator: (valueA, valueB) => {
    const dateA = valueA ? new Date(valueA) : new Date(0);
    const dateB = valueB ? new Date(valueB) : new Date(0);
    return dateA - dateB;
  }
});

/**
 * Creates ag-grid column config overrides for the GxP Relevant column.
 * @returns {object} Column config overrides
 */
export const createGxpRelevantColumnConfig = () => ({
  sortable: true,
  filter: true,
  cellRenderer: (params) => valueOrEmpty(params?.data?.equipmentDetails?.gxpRelevant, false, '-'),
  valueGetter: (params) => params?.data?.equipmentDetails?.gxpRelevant || '-',
  filterValueGetter: (params) => params?.data?.equipmentDetails?.gxpRelevant || '-'
});

/**
 * Creates ag-grid column config overrides for the Configuration Baseline column.
 * @returns {object} Column config overrides
 */
export const createConfigurationBaselineColumnConfig = () => ({
  sortable: true,
  filter: true,
  cellRenderer: (params) => {
    const value = params?.data?.logbookConfigurationBaseline?.newValue || 
                  params?.data?.instrumentDetails?.configurationBaseline;
    return valueOrEmpty(value, false, '-');
  },
  valueGetter: (params) => {
    return params?.data?.logbookConfigurationBaseline?.newValue || 
           params?.data?.instrumentDetails?.configurationBaseline || '-';
  },
  filterValueGetter: (params) => {
    return params?.data?.logbookConfigurationBaseline?.newValue || 
           params?.data?.instrumentDetails?.configurationBaseline || '-';
  }
});
